export default function getConsole(name, color, backgroundColor = null) {
  let style;

  if (backgroundColor) {
    style = `background: ${backgroundColor}; color: ${color}`;
  } else {
    style = `color: ${color}`;
  }

  const rebindMethods = ['log', 'warn', 'error', 'time', 'timeEnd'];
  const newConsole = Object.create(console);

  rebindMethods.forEach((rebindMethod) => {
    newConsole[rebindMethod] = console[rebindMethod].bind(console, `%c[${name}]`, style);
  });

  return newConsole;
}
